import { render, staticRenderFns } from "./v-checkbox-group.vue?vue&type=template&id=e55c28b2"
import script from "./v-checkbox-group.vue?vue&type=script&lang=js"
export * from "./v-checkbox-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e55c28b2')) {
      api.createRecord('e55c28b2', component.options)
    } else {
      api.reload('e55c28b2', component.options)
    }
    module.hot.accept("./v-checkbox-group.vue?vue&type=template&id=e55c28b2", function () {
      api.rerender('e55c28b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/checkbox/v-checkbox-group.vue"
export default component.exports